export default __webpack_public_path__ + "static/media/mShoes_1_c2.00844a59.jpeg";